import './style.scss';

export function article_text_block() {
    const block = document.querySelector('.article_text_block');
    if (!block) return;

}
